import { Fragment } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import { BUTTON_COLOR_MODE } from 'hb-builder/components/BuilderComponents/block/Strips/types/props';
import ButtonStyle from 'hb-builder/components/BuilderComponents/single/Button/ButtonSettings/Style/Button';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { OnChangeSetting } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { ButtonItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

interface ButtonsSettingsProps {
  buttons: DocumentItem<ButtonItemAttributes>[];
  handleBulkChange: OnChangeSetting;
  item: DocumentItem;
  onChange: OnChangeSetting;
  parentItem: DocumentItem;
}

const ButtonsSettings = ({
  buttons,
  handleBulkChange,
  item,
  onChange,
  parentItem,
}: ButtonsSettingsProps) => (
  <>
    {parentItem?.attributes?.buttonColorMode !== BUTTON_COLOR_MODE.DIFFERENT &&
      item.attributes && (
        <ButtonStyle
          defaultAttributes={item.attributes}
          item={item}
          onChange={handleBulkChange}
        />
      )}
    {parentItem?.attributes?.buttonColorMode ===
      BUTTON_COLOR_MODE.DIFFERENT && (
      <Box flexDirection="column">
        {buttons.map((button, index) => {
          const isLast = buttons.length - 1 === index;

          if (!button.attributes) {
            return null;
          }

          return (
            <Fragment key={button.id}>
              <InputTitle
                boxProps={{ mb: 3 }}
                id="settingsButtonStripsColorMode"
                label={s__('Builder|Frame %{number}').i__({
                  number: String(index + 1),
                })}
              />
              <ButtonStyle
                defaultAttributes={button.attributes}
                item={button}
                onChange={onChange}
                withDivider={false}
              />
              {!isLast && <Divider m={0} mb={4} mt={1} />}
            </Fragment>
          );
        })}
      </Box>
    )}
  </>
);

export default ButtonsSettings;
